import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type LegalDoc = {
  id: string;
  label: string;
  title: string;
  paragraphs: string[];
};
const DOCS: LegalDoc[] = [{
  id: 'privacidad',
  label: 'Política de Privacidad',
  title: 'Política de Privacidad',
  paragraphs: ['Tu privacidad es importante para nosotros. Esta política describe cómo recopilamos, usamos y protegemos la información que nos proporcionas al adquirir el Protocolo Bio-Hack 24H.', 'Recopilamos únicamente los datos necesarios para procesar tu compra y entregarte el acceso al producto digital, como tu nombre y correo electrónico. No vendemos ni compartimos tu información con terceros con fines comerciales.', 'Utilizamos proveedores de pago seguros que cumplen con los estándares de la industria para proteger tus datos financieros. Nunca almacenamos los detalles completos de tu tarjeta en nuestros servidores.', 'Puedes solicitar la eliminación de tus datos personales en cualquier momento, y procesaremos tu solicitud de acuerdo con la legislación aplicable.']
}, {
  id: 'terminos',
  label: 'Términos y Condiciones',
  title: 'Términos y Condiciones',
  paragraphs: ['Al adquirir el Protocolo Bio-Hack 24H aceptas estos términos y condiciones en su totalidad.', 'El producto consiste en material digital educativo de acceso inmediato. La licencia de uso es personal e intransferible; queda prohibida la reventa, redistribución o reproducción del contenido sin autorización expresa.', 'Nos reservamos el derecho de actualizar el contenido del protocolo para mejorar la experiencia y mantener la información vigente. Los compradores conservan el acceso a las actualizaciones del producto adquirido.', 'El uso del material es responsabilidad exclusiva del usuario. El cumplimiento de los resultados depende de la aplicación individual de cada persona.']
}, {
  id: 'descargo',
  label: 'Descargo de Responsabilidad',
  title: 'Descargo de Responsabilidad Médica',
  paragraphs: ['El Protocolo Bio-Hack 24H tiene fines exclusivamente informativos y educativos sobre optimización del bienestar.', 'Este contenido no constituye consejo médico, diagnóstico ni tratamiento, y no sustituye la consulta con un profesional de la salud calificado. Siempre consulta a tu médico antes de iniciar cualquier protocolo de suplementación, especialmente si tienes una condición médica preexistente, estás embarazada o tomas medicación.', 'Los resultados mencionados son ilustrativos y pueden variar de una persona a otra. No garantizamos resultados específicos, ya que dependen de factores individuales.', 'Al utilizar este material, reconoces que lo haces bajo tu propia responsabilidad.']
}, {
  id: 'reembolso',
  label: 'Política de Reembolso',
  title: 'Política de Reembolso',
  paragraphs: ['Queremos que tu compra sea totalmente segura. Por tratarse de un producto digital de acceso inmediato, las solicitudes de reembolso se evalúan dentro de los primeros días posteriores a la compra.', 'Si el protocolo no cumple con lo descrito, puedes solicitar la devolución de tu inversión a través del canal de soporte de la plataforma de pago utilizada.', 'Los reembolsos aprobados se procesan mediante el mismo método de pago empleado en la compra original.']
}];
export function Footer() {
  const [activeDoc, setActiveDoc] = useState<LegalDoc | null>(null);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setActiveDoc(null);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);
  return <footer className="py-12 border-t border-slate-800 bg-slate-950" data-id="element-147">
      <div className="max-w-6xl mx-auto px-6" data-id="element-148">
        <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3 mb-8" aria-label="Enlaces legales" data-id="element-149">
          {DOCS.map(doc => <button key={doc.id} onClick={() => setActiveDoc(doc)} className="text-sm text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-150">
              {doc.label}
            </button>)}
        </nav>

        <p className="text-center text-slate-500 text-sm" data-id="element-151">
          © {new Date().getFullYear()} Protocolo Bio-Hack 24H. Todos los
          derechos reservados.
        </p>
        <p className="mt-3 max-w-2xl mx-auto text-center text-xs text-slate-600" data-id="element-152">
          Este producto no sustituye el consejo médico profesional, diagnóstico
          o tratamiento. Siempre busque el consejo de su médico u otro proveedor
          de salud calificado con cualquier pregunta que pueda tener sobre una
          condición médica.
        </p>
      </div>

      <AnimatePresence data-id="element-153">
        {activeDoc && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-sm" onClick={() => setActiveDoc(null)} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-154">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-[85vh] overflow-hidden rounded-2xl bg-slate-900 border border-slate-800 shadow-2xl flex flex-col" data-id="element-155">
              <div className="flex items-center justify-between px-6 py-5 border-b border-slate-800 shrink-0" data-id="element-156">
                <h2 id="legal-modal-title" className="text-xl font-bold text-white pr-8" data-id="element-157">
                  {activeDoc.title}
                </h2>
                <button onClick={() => setActiveDoc(null)} className="text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg p-2 transition-colors" aria-label="Cerrar" data-id="element-158">
                  <X className="w-5 h-5" data-id="element-159" />
                </button>
              </div>
              <div className="px-6 py-6 overflow-y-auto space-y-4" data-id="element-160">
                {activeDoc.paragraphs.map((p, i) => <p key={i} className="text-slate-400 leading-relaxed" data-id="element-161">
                    {p}
                  </p>)}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </footer>;
}